import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"

export interface SearchLogFilterValues {
  search?: string
  match_type?: string
  commit_method?: string
}

interface SearchLogFilterFormProps {
  onSearch: (values: SearchLogFilterValues) => void
  loading?: boolean
  initialValues?: SearchLogFilterValues
}

const MATCH_TYPE_OPTIONS = [
  { label: "Tất cả loại match", value: "" },
  { label: "Exact (Tuyệt đối)", value: "exact" },
  { label: "Fuzzy (Gần đúng)", value: "fuzzy" },
  { label: "AI (Từ điển AI)", value: "ai" },
  { label: "None (Không có)", value: "none" },
]

const COMMIT_METHOD_OPTIONS = [
  { label: "Tất cả phương thức", value: "" },
  { label: "Keyboard (Bàn phím)", value: "keyboard" },
  { label: "Pointer (Chuột/Click)", value: "pointer" },
]

export const SearchLogFilterForm: React.FC<SearchLogFilterFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  const handleFinish = (values: SearchLogFilterValues) => {
    onSearch({
      search: values.search?.trim() || undefined,
      match_type: values.match_type || undefined,
      commit_method: values.commit_method || undefined,
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: undefined,
      match_type: undefined,
      commit_method: undefined,
    })
  }

  return (
    <Card className="mb-2 shadow-xs">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          search: initialValues?.search || "",
          match_type: initialValues?.match_type || "",
          commit_method: initialValues?.commit_method || "",
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Người dùng (Tên, Email hoặc #ID)" name="search">
              <Input placeholder="Nhập tên, email hoặc #ID..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Loại Match" name="match_type">
              <Select options={MATCH_TYPE_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Phương thức chọn" name="commit_method">
              <Select options={COMMIT_METHOD_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default SearchLogFilterForm
